import React from 'react';
import C from '../colors';

// Inject keyframe once
if (typeof document !== 'undefined' && !document.getElementById('skeleton-style')) {
  const style = document.createElement('style');
  style.id = 'skeleton-style';
  style.textContent = `
    @keyframes skeletonPulse {
      0%, 100% { opacity: 1 }
      50%       { opacity: 0.4 }
    }
  `;
  document.head.appendChild(style);
}

function Block({ width = '100%', height = 14, radius = 6, style }) {
  return (
    <div style={{
      width, height, borderRadius: radius,
      background: C.hair,
      animation: 'skeletonPulse 1.4s ease-in-out infinite',
      flexShrink: 0,
      ...style,
    }}/>
  );
}

function RowCard() {
  return (
    <div style={{
      background: '#fff', border: `1px solid ${C.hair}`,
      borderRadius: 14, padding: '24px 26px', marginBottom: 18,
    }}>
      {/* header row */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 18 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, flex: 1 }}>
          <Block width={80} height={10}/>
          <Block width={220} height={26} radius={8}/>
          <Block width={300} height={10}/>
        </div>
        <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
          <Block width={100} height={34} radius={7}/>
          <Block width={34} height={34} radius={7}/>
          <Block width={34} height={34} radius={7}/>
        </div>
      </div>
      {/* progress bar */}
      <Block width="100%" height={4} radius={2} style={{ marginBottom: 16 }}/>
      {/* stats row */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 18, padding: '14px 0', borderTop: `1px solid ${C.hair}`, borderBottom: `1px solid ${C.hair}`, marginBottom: 16 }}>
        {Array.from({ length: 5 }, (_, i) => (
          <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <Block width={40} height={9}/>
            <Block width={60} height={20} radius={4}/>
          </div>
        ))}
      </div>
      {/* photo strip */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', gap: 6 }}>
        {Array.from({ length: 8 }, (_, i) => (
          <Block key={i} width="100%" height={0} radius={6} style={{ aspectRatio: '4/3', height: 'auto' }}/>
        ))}
      </div>
    </div>
  );
}

function GridCard() {
  return (
    <div style={{
      background: '#fff', border: `1px solid ${C.hair}`,
      borderRadius: 12, overflow: 'hidden',
    }}>
      <Block width="100%" height={160} radius={0}/>
      <div style={{ padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 10 }}>
        <Block width={140} height={20} radius={6}/>
        <Block width="90%" height={10}/>
        <Block width="70%" height={10}/>
        <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
          <Block width="50%" height={32} radius={7}/>
          <Block width="50%" height={32} radius={7}/>
        </div>
      </div>
    </div>
  );
}

export default function ListSkeleton({ variant = 'rows', count }) {
  if (variant === 'grid') {
    const n = count ?? 8;
    return (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16 }}>
        {Array.from({ length: n }, (_, i) => <GridCard key={i}/>)}
      </div>
    );
  }

  const n = count ?? 3;
  return (
    <div>
      {Array.from({ length: n }, (_, i) => <RowCard key={i}/>)}
    </div>
  );
}
